import { render } from "./MapaBrazil.vue?vue&type=template&id=26e947ad&scoped=true"
import script from "./MapaBrazil.vue?vue&type=script&lang=js"
export * from "./MapaBrazil.vue?vue&type=script&lang=js"

import "./MapaBrazil.vue?vue&type=style&index=0&id=26e947ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e947ad"]])

export default __exports__